import * as React from 'react';

import { getMemberNotifications } from 'libs/apis';
import type { Notification } from 'components/notification/type';
import { updateLocalStorage } from 'components/notification/libs/localStorageService';
import NotificationListPageView from './NotificationListPageView';

const NotificationListPage: React.FC = () => {
  const [currentPage, setCurrentPage] = React.useState<number>(1);
  const [totalPage, setTotalPage] = React.useState<number | null>(null);
  const [notifications, setNotifications] = React.useState<Notification[] | null>(null);

  const changePage = React.useCallback((newPage: number) => {
    setCurrentPage(newPage);
    // ページ遷移したときにスクロール位置をトップに戻す
    window.scrollTo(0, 0);
  }, []);

  // お知らせ一覧を開いたら既読になるのでなるのでタイムスタンプを更新する
  React.useEffect(() => {
    updateLocalStorage(new Date());
  }, []);

  React.useEffect(() => {
    getMemberNotifications({ page: currentPage }).then((res) => {
      setNotifications(res.memberNotifications);
      setTotalPage(res.totalPage!);
    });
  }, [currentPage]);

  return (
    <NotificationListPageView
      notifications={notifications}
      currentPage={currentPage}
      totalPage={totalPage}
      changePage={changePage}
    />
  );
};

export default NotificationListPage;
